/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

const processENV = process?.env?.NODE_ENV;
const myConsoleLog = (...args) => {
    if (processENV === 'development') {
        console.log(...args);
    }
};

const feather = require('feather-icons');
const Turbolinks = require('turbolinks');
const Notifications = require('./library/notifications').default;
const Vue = require('vue').default;
const VueSweetalert2 = require('vue-sweetalert2');

Turbolinks.start();

Vue.use(Notifications);
Vue.use(VueSweetalert2);

window.myConsoleLog = myConsoleLog;
window.Turbolinks = Turbolinks;
window.Vue = Vue;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

let app;

let documentInit = () => {
    // every-page will execute this.
    myConsoleLog('Page Init is start.');

    app = new Vue({
        el: '#vue-app'
    });

    if (feather) {
        feather.replace();
    }

    if (Turbolinks) {
        // disable turbolinks on same page or empty links
        document.querySelectorAll('a[href^="#"]')
            .forEach(element => element.setAttribute('data-turbolinks', false));
    }
};

if (Turbolinks) {
    // only execute once.
    myConsoleLog('Global Turbolinks Init is start.');

    // doing document Init every turbolinks-load
    document.addEventListener('turbolinks:load', documentInit);

    // make sure vue been destroyed before render
    document.addEventListener('turbolinks:before-render', () => {
        if (app instanceof Vue) app.$destroy();
    });

    // make sure turbolinks handle 302 header
    document.addEventListener('turbolinks:request-end', (e) => {
        const responseURL = e?.data?.xhr?.responseURL;
        const responseStatus = e?.data?.xhr?.status;
        const windowURL = window?.location?.href;

        if (windowURL.replace(/\/$/, '') !== responseURL.replace(/\/$/, '')) {
            myConsoleLog('Update history state with responseURL.');
            history.replaceState(responseStatus, document.title, responseURL);
        }
    });
} else documentInit();
